
export const getNotificationNumbers = async ({ socket}) => {


    socket.emit('get_number_of_notifications', {})
}


export const onNumberNotifications = ({ socket, setNumberNotifications }) => {
    socket.off('number_notifications')
    socket.on('number_notifications', (pckg) => {
        // devLog("Got number of notifications", pckg.unread, pckg.total)
        // devLog("number of notifications", pckg.unread)
        setNumberNotifications((prev) => pckg.unread)
    })

}


export const onUnreadMessages = async ({ socket, setNewMessageNotifications }) => {
    socket.off('unread_messages')
    socket.on('unread_messages', (pckg) => {
        // devLog("unread messages", pckg.unread_chats)
        setNewMessageNotifications((prev) => pckg.unread_chats)
    })
}

export const onUnreadMessage = async ({ socket, setNewMessageNotifications }) => {
    socket.off('unread_message')
    socket.on('unread_message', (pckg) => {
        setNewMessageNotifications((prev) => ({...prev, [pckg.unread_chat.room_id]: pckg.unread_chat}))
    })
}

export const getUnreadMessages = async ({ socket, userId }) => {
    socket.emit('get_unread_messages', { user_id: userId })
    setTimeout(() => {
    }, 50)
}


export const onTicketUpdatedPing = async ({ socket, setTickets }) => {
    socket.off('ticket_updated_ping')
    socket.on('ticket_updated_ping', (pckg) => {
        // devLog('on ticket_updated_ping', pckg)
        setTickets(prevTickets => {
            let ticketIndex = prevTickets.findIndex((el) => String(el.id) === String(pckg.ticket_id))
            let ticket = prevTickets[ticketIndex]
            if (ticket) {

                ticket.lastUpdated = pckg.lastUpdated
                ticket.category = pckg.category !== null ? pckg.category : ticket.category
                ticket.status = pckg.status !== null ? pckg.status : ticket.status
                ticket.priority = pckg.priority !== null ? pckg.priority : ticket.priority
                ticket.banned = pckg.banned ? pckg.banned : false
                if (pckg.assignedTo === "" || pckg.assignedTo === null) {
                    ticket.assignedTo = null
                }
                else if (pckg.assignedTo !== null) {
                    ticket.assignedTo = pckg.assignedTo
                }

                prevTickets[ticketIndex] = ticket
            }


            let sortedByStatus = {
                "NEW TICKET" : [],
                "WAITING DEV" : [],
                "ON HOLD": [],
                "REPLIED" : [],
                "RESOLVED" : [],
                "CLOSED": []
            }

            for (let i=0; i < prevTickets.length; i++ ) {
                let ticket = prevTickets[i]
                sortedByStatus[ticket.status].push(ticket)
            }
            
            let sortedByUpdate = {}
            for (const [status, tickets] of Object.entries(sortedByStatus)) {
                sortedByUpdate[status] = tickets.sort((b, a) => parseInt(a.lastUpdated) - parseInt(b.lastUpdated))
            }

            let sorted = []

            sorted.push(...sortedByUpdate["NEW TICKET"])
            sorted.push(...sortedByUpdate["WAITING DEV"])
            sorted.push(...sortedByUpdate["ON HOLD"])
            sorted.push(...sortedByUpdate["REPLIED"])
            sorted.push(...sortedByUpdate["RESOLVED"])
            sorted.push(...sortedByUpdate["CLOSED"])
            return sorted
            // setChatTickets(sorted)

            // return [...prevTickets.sort((b, a) => parseInt(a.lastUpdated) - parseInt(b.lastUpdated))]
        })
    })

}


export const onNewNotification = async ({socket, setNewNotifications, playSound, showNotification}) => {
    socket.off('new_notification')
    socket.on('new_notification', (pckg) => {
        let notification = pckg.notification
        notification.expires = Date.now() + 5000
        playSound(`${pckg.notification.type}Notification1`)
        setNewNotifications((prevNotifications) => [...prevNotifications, notification])
        if (showNotification) {
            showNotification(notification)
        }
    })
}